import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 sm:gap-6 lg:gap-8" }
const _hoisted_3 = { class: "card col-span-2" }
const _hoisted_4 = { class: "flex flex-wrap items-center justify-between sm:flex-nowrap px-4 py-[14px] sm:px-6 bg-white relative overflow-hidden" }
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = {
  href: "/DBServices-W9-2026.pdf",
  target: "_blank"
}
const _hoisted_7 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_8 = { class: "md:hidden !font-normal mt-4" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "md:hidden mt-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }

import api from '@/utilities/api'

	import {
		isDueOnReceipt,
		isPayable,
		showStatusBadge,
		invoiceStatusColor,
		invoiceStatusLabel,
		clearPendingVerification,
		applyInvoiceDueStatus,
		amountDueWithoutProcessingFee
	} from '@/utilities/invoiceStatus'

	import {
		Auth
	} from 'aws-amplify'

	// components
	import InvoiceDetailsButton from "./components/InvoiceDetailsButton.vue"
	import PayButton from './components/PayButton.vue'

	import {
		ArrowDownTrayIcon,
	} from "@heroicons/vue/20/solid"

	// vue
	import {
		ref,
		onMounted
	} from "vue"

	
	const __default__ = { name: 'InvoicesMain' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// api
	const loading = ref(true)
	const invoices = ref<Array<any>>([])

	const currencyFormatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
	})

	onMounted(() => {
		getInvoices()
	})

	// pulls the invoice list for the logged in contact out of FileMaker
	async function fetchInvoiceList() {
		const user = await Auth.currentAuthenticatedUser()

		const body = {
			action: "invoiceList",
			payload: {
				id: user.attributes['custom:fm_contact_id'],
				companyID: user.attributes['custom:fm_company_id']
			}
		}
		const response = await api("post", "fmDataAPI", "/fmDataAPI", body)
		const scriptResult = JSON.parse(response.response.scriptResult)

		return scriptResult.result.data
	}

	async function getInvoices() {
		try {
			loading.value = true

			const todayDate = new Date()

			let _invoices = await fetchInvoiceList()

			// filter pending invoices for now
			_invoices = _invoices?.filter((invoice: any) => {
				return invoice.status != "Pending"
			})
			_invoices = _invoices.filter((invoice: any) => {
				return invoice.status != "Cancelled"
			})

			_invoices.forEach((invoice: any) => {
				//  split invoices summaries string
				invoice.summaries = invoice.summaries.split("\r")

				applyInvoiceDueStatus(invoice, todayDate)
			})

			invoices.value = _invoices
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loading.value = false
		}
	}


return (_ctx: any,_cache: any) => {
  const _component_tw_button = _resolveComponent("tw-button")!
  const _component_card_header_backdrop = _resolveComponent("card-header-backdrop")!
  const _component_tw_badge_flat = _resolveComponent("tw-badge-flat")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full mb-5 flex justify-between" }, [
      _createElementVNode("h1", { class: "text-3xl font-black text-dbBlue" }, " Invoices ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "card-heading" }, " All Invoices ")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, [
              _createVNode(_component_tw_button, { class: "btn-base btn-indigo w-44" }, {
                icon_right: _withCtx(() => [
                  _createVNode(_unref(ArrowDownTrayIcon), { class: "w-5 h-5" })
                ]),
                default: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createTextVNode(" Download our W-9 "))
                ]),
                _: 1,
                __: [0]
              })
            ])
          ]),
          _createVNode(_component_card_header_backdrop, { class: "opacity-20" })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_tw_table, {
            data: invoices.value,
            loading: loading.value,
            placeholder: "No Invoices"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tw_table_column, {
                condensed: "",
                header: "Invoice #",
                prop: "invoiceNumber",
                "class-name": "font-bold text-gray-900"
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(row.invoiceNumber) + " ", 1),
                  _createElementVNode("div", _hoisted_8, [
                    (_unref(showStatusBadge)(row))
                      ? (_openBlock(), _createBlock(_component_tw_badge_flat, {
                          key: 0,
                          color: _unref(invoiceStatusColor)(row)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(invoiceStatusLabel)(row)), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(row.paymentTerms), 1))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                condensed: "",
                header: "Amount Due"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("span", {
                    class: _normalizeClass({'text-red-600': row.isOverdue, 'text-yellow-600' : !row.isOverdue && row.status === 'Invoiced'})
                  }, _toDisplayString(_unref(currencyFormatter).format(_unref(amountDueWithoutProcessingFee)(row))), 3),
                  _createElementVNode("div", _hoisted_10, [
                    (!_unref(isDueOnReceipt)(row.paymentTerms))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(row.dueDate), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(row.paymentTerms), 1))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                condensed: "",
                "class-name": "hidden md:table-cell",
                "header-class-name": "hidden md:table-cell",
                header: "Invoice Date",
                prop: "invoiceDate"
              }),
              _createVNode(_component_tw_table_column, {
                header: "Due Date",
                "header-class-name": "hidden md:table-cell",
                "class-name": "hidden md:table-cell",
                prop: "dueDate"
              }, {
                default: _withCtx(({row}) => [
                  (!_unref(isDueOnReceipt)(row.paymentTerms))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row.dueDate), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(row.paymentTerms), 1))
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                "class-name": "hidden md:block",
                "header-class-name": "hidden md:block",
                header: "Status",
                prop: "status"
              }, {
                default: _withCtx(({row}) => [
                  (_unref(showStatusBadge)(row))
                    ? (_openBlock(), _createBlock(_component_tw_badge_flat, {
                        key: 0,
                        color: _unref(invoiceStatusColor)(row)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(invoiceStatusLabel)(row)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(row.paymentTerms), 1))
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                condensed: "",
                "class-name": "hidden md:table-cell w-44",
                "header-class-name": "hidden md:table-cell sr-only w-44",
                header: "Pay"
              }, {
                default: _withCtx(({ row }) => [
                  (_unref(isPayable)(row) && !loading.value)
                    ? (_openBlock(), _createBlock(PayButton, {
                        key: 0,
                        invoice: row,
                        onSubmitted: getInvoices,
                        onVerificationCanceled: ($event: any) => (_unref(clearPendingVerification)(row))
                      }, null, 8, ["invoice", "onVerificationCanceled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                condensed: "",
                header: "View Details",
                "header-class-name": "sr-only",
                "class-name": "text-center md:text-right"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(InvoiceDetailsButton, { invoice: row }, null, 8, ["invoice"]),
                  (_unref(isPayable)(row) && !loading.value)
                    ? (_openBlock(), _createBlock(PayButton, {
                        key: 0,
                        class: "md:hidden mt-4",
                        invoice: row,
                        onSubmitted: getInvoices,
                        onVerificationCanceled: ($event: any) => (_unref(clearPendingVerification)(row))
                      }, null, 8, ["invoice", "onVerificationCanceled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "loading"])
        ])
      ])
    ])
  ]))
}
}

})